interface WsLog {
  channel: string;
  params: object | undefined;
  timestamp: string;
  message: any;
}

const LOGS_LIFE_TIME = 60000; // 1 min

let enabled = false;
const logs: WsLog[] = [];

function enable() {
  enabled = true;
}

function disable() {
  enabled = false;
  logs.splice(0, logs.length); // clear logs list
}

function log(channel: string, params: object | undefined, data: any): void {
  if (enabled) {
    logs.push({
      channel,
      params,
      timestamp: new Date().toISOString(),
      message: data
    });

    // each time we log a ws message, we clean old messages
    clearOldLogs();
  }
}

function clearOldLogs() {
  const timestampLimit = Date.now() - LOGS_LIFE_TIME;
  const dateLimit = new Date(timestampLimit).toISOString();
  // as logs are push with increasing, we can loop until we reach timestamp limit
  while (logs[0] && logs[0].timestamp < dateLimit) {
    logs.shift();
  }
}

function exportFile() {
  const now = new Date().toISOString();
  const json = JSON.stringify(logs);

  const blob = new Blob([json], { type: 'text/plain;charset=utf-8' });

  const objectURL = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.download = `dashboard_real_time_logs-${now}.json`;
  a.href = objectURL;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectURL);
}

export { enable, disable, log, exportFile };
